import React, { useCallback, useEffect, useRef } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { Theme } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

import { createStyles, makeStyles } from '@material-ui/styles';
import { Button } from '..';
import keyCodeConverter from '../../utility/keyCodeConverter';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    padding: 'unset',
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  disabled: palette.disabledButton,
}), { name: 'submit' });

const FormSubmit = ({
  children,
  disabled,
  classes,
  ...props
}: ButtonProps) => {
  const styles = useStyles();
  const refSubmit = useRef<HTMLButtonElement>(null);
  const { formState } = useFormContext();

  useEffect(() => {
    const save = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === keyCodeConverter('s') && formState.isValid) {
        event.preventDefault();
        refSubmit.current?.click();
      }
    };
    window.addEventListener('keydown', save);
    return () => {
      window.removeEventListener('keydown', save);
    };
  }, [refSubmit, formState]);

  const onClickHandler = useCallback((e: React.MouseEvent<HTMLElement>) => {
    // e.stopPropagation();
  }, []);

  return (
    <Button
      onClick={(e) => onClickHandler(e)}
      disabled={!formState.isValid || disabled}
      ref={refSubmit}
      type="submit"
      classes={{
        ...styles,
        ...classes,
      }}

      {...props}
    >
      {children}
    </Button>
  );
};

export default FormSubmit;
